import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_46.module.css";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter46.json";
import Common_html from "./Common_html";

function Chapter_46() {
    // const corosalref = useRef()

    // useEffect(() => {
    //     if (corosalref.current) {
    //         corosalref.current.scrollIntoView({
    //             behavior: "smooth",
    //             block: "nearest",
    //             inline: "start"
    //         })
    //     }
    //     console.log("CurrentImageComponent", corosalref.current);
    // }, [corosalref.current])
    return (
        <>
            <Head>
                <title>THE VERY POINT OF THE SINGULARITY | School of Our Divine Infinite Being</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                ></meta>
                <meta
                    name="keywords"
                    content="Divine Infinite Being, Central Doctrine, Chapter-XLVI"
                ></meta>
                <meta
                    property="og:title"
                    content="THE VERY POINT OF THE SINGULARITY | School of Our Divine Infinite Being"
                ></meta>
                <meta property="og:type" content="website"></meta>
                <meta
                    property="og:image"
                    content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
                ></meta>
                <meta property="og:image:alt" content="Visual representation of the singularity, depicting the convergence of all matter, energy, and consciousness into a single point, symbolizing the origin of existence and its connection to the Divine Infinite Being."></meta>
                <meta
                    property="og:description"
                    content="Uncover the Divine Infinite Being's insights on the singularity, the ultimate point of creation where all potentialities converge. Explore the profound spiritual implications of this cosmic moment, symbolizing the unity of existence and the source of all life and consciousness."
                ></meta>

                <meta property="og:image:width" content="1200"></meta>
                <meta property="og:image:height" content="627"></meta>
                <meta
                    property="og:url"
                    content="https://www.divineinfinitebeing.com/central-doctrine?chapter=46"
                ></meta>

                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
                <meta property="twitter:image:alt" content="Visual representation of the singularity, depicting the convergence of all matter, energy, and consciousness into a single point, symbolizing the origin of existence and its connection to the Divine Infinite Being."></meta>
                <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=46"></meta>
                <meta name="twitter:title" content="THE VERY POINT OF THE SINGULARITY | School of Our Divine Infinite Being"></meta>
                <meta name="twitter:description" content="Uncover the Divine Infinite Being's insights on the singularity, the ultimate point of creation where all potentialities converge. Explore the profound spiritual implications of this cosmic moment, symbolizing the unity of existence and the source of all life and consciousness."></meta>
                <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=46" />
            </Head>
            <Common_html BlockData={BlockData} />
        </>
    );
}

export default Chapter_46;
